/* eslint-disable */

/**
 * Lives outside of models.proto because of enum name conflicts with TransferType
 * TODO: merge this back into models.proto
 */
export enum TransferRail {
  DEBIT = "DEBIT",
  ACH = "ACH",
}
